import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Api from '../utils/Api'
import { Chart, Line } from 'react-chartjs-2'
import { ChartHeader } from './ChartHeader'
import { chartOptions } from '../utils/chartOptions'
//import html2canvas from 'html2canvas'

const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export class ChartComponent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      charts: [],
      dateContent: ''
    }

    this.chartOptions = JSON.parse(JSON.stringify(chartOptions))
    this.api = new Api()
  
  }

  componentDidMount() {
    this.updateChart()

    this.chartOptions.tooltips.custom = (tooltip) => {
        if (typeof tooltip.dataPoints != "undefined" && tooltip.dataPoints.length > 0) {
            tooltip.dataPoints.map((dataPoint) => {
                this.setState({
                  dateContent: this.state.chart.labels[dataPoint.index].toString()
                })
            })
        } else {
            this.setState({
              dateContent: ''
            })
        }
    }
    
  }

  updateChart = () => {
    const data = this.props.data

    const defaults = {
      fill: true,
      pointRadius: 0,
      backgroundColor: 'transparent',
      borderWidth: 1.5,
      hidden: false,
      borderColor: '#349AEE'
    }

    let labels = []
    let scores = []

    data.dataset.forEach((obj) => {
      const { ts, score } = obj
      const date = new Date(ts)
      
      const month = monthNames[date.getMonth()]
      labels.push(ts)
      scores.push(score)
    })  
    
    this.setState({
      chart: {
        labels,
        datasets:
        [{
          ...defaults,
          data: scores,
          label: data.name
        }]
      }
    })
  }
  

  render() {
    // const saveChart = async () => {
    //   const chart = document.getElementById(`chart-${this.props.id}`)
    //   const canvas = await html2canvas(chart)
    //   const b64 = canvas.toDataURL()

    //   var link = document.createElement('a'), e
    //   link.download = `Glimpse - ${this.props.data.name}.png`
    //   link.href = b64
    //   if (document.createEvent) {
    //     e = document.createEvent("MouseEvents");
    //     e.initMouseEvent("click", true, true, window,
    //                      0, 0, 0, 0, 0, false, false, false,
    //                      false, 0, null);
    
    //     link.dispatchEvent(e);
    //   } else if (link.fireEvent) {
    //     link.fireEvent("onclick");
    //   }

      // const imageRes = await this.api.uploadImg(b64)
      // const url = `https://o9w1g.sse.codesandbox.io/images/${imageRes.data.name}`
      // console.log(url)

      // const win = window.open(
      //   `https://twitter.com/intent/tweet?text=This%20trend%20is%20exploding!%20${url}`,
      //   '_blank'
      // )
      // win.focus()

    // }

    const d = new Date(Math.floor(this.state.dateContent * 1000))
    const months = ['January','February','March','April','May','June','July','August','September','October','November','December']

    const date = {
      month: months[d.getMonth()],
      day: d.getDate(),
      year: d.getFullYear()
    }

    return (
      <Col xs={12} sm={12} md={6} lg={4} className='chart-col'>
        <div className='chart' id={`chart-${this.props.id}`} >
          <ChartHeader 
            name={this.props.data.name}
            percent={this.props.data.change}
            growthCat={this.props.data.growth_category}
            description={this.props.data.description}
          />
          <Row className='chart-row'>
            <div style={{ width: '100%' }}>
            <Line
              data={this.state.chart} 
              height={null}
              width={null}
              options={this.chartOptions}
              marginTop={15}
            />
            </div>
            {/* <img src={require('../assets/glimpse-blue.png')} style={{ opacity: 0.5, position: 'absolute', right: 25, bottom: 25, width: 80 }} /> */}
            <div style={{ height: '20px', width: '100%', textAlign: 'center', marginTop: 7, color: '#2f2f2f', fontFamily: 'Inter', fontWeight: 300 }}>{ this.state.dateContent !== '' && `${date.day} ${date.month}, ${date.year}` }</div>
            {/* <div className="share" onClick={saveChart}>DOWNLOAD</div> */}
          </Row>
        </div>
      </Col>
    )
  }
}
